import React from 'react';
import MeetingParticipantsList from './MeetingParticipantsList';

/**
 * The participants panel's content card, framed by the shared MeetingRightPanel
 * slot.
 */
const MeetingParticipantsPanel = () => <MeetingParticipantsList />;

export default MeetingParticipantsPanel;
